import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivePanelEnum } from '@app/core';
import { Claim } from '@app/core/interfaces/claim';
import { Dossier } from '@app/core/interfaces/dossier';
import { MyZoneRoutesEnum } from '@app/my-zone/my-zone-routes.enum';
import { ClaimsRoutingEnum } from '@app/my-zone/pages/claims/claims-routing.enum';
import { AppRoutesEnum } from '@app/routes';

const ORGANISATION_ID = 'LGSH';
const DAS_HANDLER_ID = 1000009;
const SAR_HANDLER_ID = 1062755;

@Component({
    selector: 'ins-claim-item',
    templateUrl: './claim-item.component.html',
    styleUrls: ['./claim-item.component.scss'],
})
export class ClaimItemComponent implements OnInit {

    public isLegalsharedBehandelaar: boolean = false;
    public isDasBehandelaar: boolean = false;
    public isSarBehandelaar: boolean = false;
    public activePanel = ActivePanelEnum;

    @Input() dossier: Dossier;

    constructor(
        private router: Router,
    ) {}

    ngOnInit(): void {
        // Legal Shared
        if (this.isLegalShared(this.dossier.claim)) {
            this.isLegalsharedBehandelaar = true;
        }

        // DAS behandelaar
        if (this.hasClaims() && this.isBehandelaar(DAS_HANDLER_ID)) {
            this.isDasBehandelaar = true;
        }

        // Stichting Achmea Rechtsbijstand
        if (this.hasClaims() && this.isBehandelaar(SAR_HANDLER_ID)) {
            this.isSarBehandelaar = true;
        }
    }

    public navigateTo(section: ActivePanelEnum): boolean {
        const defaultQueryParams = {
            d: this.dossier.dossier_volgnummer,
        };
        const panelQueryParams = {
            ...defaultQueryParams,
            scroll: true,
            expand: true,
            section,
        };

        if (section) {
            this.router.navigate([AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyClaims, ClaimsRoutingEnum.DamageClaim], {
                queryParams: panelQueryParams,
            });
        } else {
            this.router.navigate([AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyClaims, ClaimsRoutingEnum.DamageClaim], {
                queryParams: defaultQueryParams,
            });
        }

        return false;
    }

    private isLegalShared(claim: Claim[]): boolean {
        if (!claim) {
            return false;
        }

        claim.forEach((_claim) => {
            if (_claim.behandelaar && _claim.behandelaar.behandelaar_organisatie_id === ORGANISATION_ID) {
                return true;
            }
        });

        return false;
    }

    private hasClaims(): boolean {
        if (this.dossier.claim && this.dossier.claim.length > 0) {
            return true;
        }
        return false;
    }

    private isBehandelaar(adresRelatieId: number): boolean {
        if (!this.dossier.claim[0].behandelaar) {
            return false;
        }
        if (this.dossier.claim[0].behandelaar.adres_relatie_id !== adresRelatieId) {
            return false;
        }
        return true;
    }
}
